import { apiClient } from "./client";

export type TokenPair = {
  access_token: string;
  refresh_token: string;
  token_type: "bearer";
  expires_in: number;
};

export type AccessibleOrg = {
  id: string;
  code: string;
  name: string;
  role_code: string;
};

export type RoleEntry = {
  scope: "GOD" | "TENANT" | "ORG";
  scope_id: string | null;
  role_code: string;
  permissions: string[];
};

export type Me = {
  id: string;
  email: string;
  full_name: string | null;
  tenant_id: string | null;
  is_god: boolean;
  locale: string;
  theme_pref: string;
  active_org_id: string | null;
  accessible_orgs: AccessibleOrg[];
  roles: RoleEntry[];
  /** True while an admin-issued temporary password has not been replaced.
   *  The API refuses every permission-gated endpoint until it is. */
  must_change_password: boolean;
};

export async function login(
  email: string,
  password: string,
  mfaCode?: string,
): Promise<TokenPair> {
  const body: Record<string, string> = { email, password };
  if (mfaCode) body.mfa_code = mfaCode;
  const { data } = await apiClient.post<TokenPair>("/api/v1/auth/login", body);
  return data;
}

export async function refresh(refresh_token: string): Promise<TokenPair> {
  const { data } = await apiClient.post<TokenPair>("/api/v1/auth/refresh", { refresh_token });
  return data;
}

export async function fetchMe(): Promise<Me> {
  const { data } = await apiClient.get<Me>("/api/v1/auth/me");
  return data;
}

export async function logoutCall(): Promise<void> {
  await apiClient.post("/api/v1/auth/logout");
}
